import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.flexara.ro';

const ResetParola: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [parola, setParola] = useState('');
  const [parola2, setParola2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const inputStyle: React.CSSProperties = {
    padding: '0.75rem',
    borderRadius: '10px',
    border: '1.5px solid #2a2a4a',
    background: '#0a0a1a',
    color: '#e0e0f0',
    fontSize: '1rem',
    width: '100%',
    boxSizing: 'border-box',
  };

  const handleSubmit = async () => {
    setError('');
    if (parola.length < 6) { setError('Parola trebuie să aibă minim 6 caractere!'); return; }
    if (parola !== parola2) { setError('Parolele nu coincid!'); return; }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/reset-confirm`, {
        token,
        parola_noua: parola,
      });
      setSuccess(true);
    } catch (e: any) {
      setError(e.response?.data?.detail || 'Eroare — încearcă din nou!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a1a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'DM Sans, sans-serif',
      padding: '1rem',
    }}>
      <div style={{
        background: '#1a1a30',
        borderRadius: '16px',
        padding: '2.5rem',
        width: '100%',
        maxWidth: '420px',
        border: '1px solid #2a2a4a',
      }}>
        <h1 style={{ color: '#fff', marginBottom: '0.5rem' }}>🔑 Flexara</h1>
        <p style={{ color: '#8080a0', marginBottom: '2rem' }}>Resetare parolă</p>

        {!token ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#ff6060', marginBottom: '1.5rem' }}>Link invalid sau expirat.</p>
            <button onClick={() => navigate('/login')} style={{
              width: '100%', padding: '0.75rem', borderRadius: '10px', border: 'none',
              background: '#4a4ad8', color: '#fff', fontSize: '1rem',
              fontWeight: 600, cursor: 'pointer',
            }}>
              Înapoi la autentificare
            </button>
          </div>
        ) : success ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#60d090', marginBottom: '1.5rem', fontSize: '1rem' }}>
              Parola a fost resetată! Te poți loga acum.
            </p>
            <button onClick={() => navigate('/login')} style={{
              width: '100%', padding: '0.75rem', borderRadius: '10px', border: 'none',
              background: '#4a4ad8', color: '#fff', fontSize: '1rem',
              fontWeight: 600, cursor: 'pointer',
            }}>
              Mergi la autentificare
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {error && (
              <p style={{ color: '#ff6060', fontSize: '0.9rem', margin: 0 }}>{error}</p>
            )}
            <input
              type="password"
              placeholder="Parolă nouă"
              value={parola}
              onChange={e => setParola(e.target.value)}
              style={inputStyle}
            />
            <input
              type="password"
              placeholder="Confirmă parola nouă"
              value={parola2}
              onChange={e => setParola2(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={inputStyle}
            />
            <p style={{ color: '#5a5a7a', fontSize: '0.8rem', margin: 0 }}>
              Minim 6 caractere.
            </p>
            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                padding: '0.75rem', borderRadius: '10px', border: 'none',
                background: '#4a4ad8', color: '#fff', fontSize: '1rem',
                fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Se procesează...' : 'Resetează parola'}
            </button>
            <button onClick={() => navigate('/login')} style={{
              padding: '0.6rem', borderRadius: '10px',
              border: '1px solid #2a2a4a', background: 'transparent',
              color: '#6060a0', cursor: 'pointer', fontSize: '0.9rem',
            }}>
              Înapoi la autentificare
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetParola;
